export default __webpack_public_path__ + "37c93c90f6dba7be4493c563612a2982.png";